import { useStrings } from "@1js/localization-components";
import { Button, type ButtonProps } from "@fluentui/react-components";
import { Dismiss24Regular } from "@fluentui/react-icons";
import * as React from "react";
import { PromptLibraryDialogClose } from "./PromptLibraryCloseButton.strings";

export const PromptLibraryCloseButton: React.FC<ButtonProps> = (props) => {
  const localizations = useStrings({
    PromptLibraryDialogClose,
  });

  return (
    <Button
      icon={<Dismiss24Regular />}
      appearance="subtle"
      aria-label={localizations.PromptLibraryDialogClose()}
      {...props}
    />
  );
};
